import React, { useEffect, useState } from "react";
import ReactApexChart from "react-apexcharts";

const LineChart = ({ lineChartData, lineChartOptions }) => {
  const [chartData, setChartData] = useState(lineChartData || []);
  const [chartOptions, setChartOptions] = useState(lineChartOptions || {});

  useEffect(() => {
    setChartData(lineChartData);
    setChartOptions(lineChartOptions);
  }, [lineChartData, lineChartOptions]);

  return (
    <ReactApexChart
      options={chartOptions}
      series={chartData}
      type="area"
      width="100%"
      height="100%"
    />
  );
};

export default LineChart;